// Destructive-op gate for "replace graph" loads. Replace drops the target
// graph before writing, so a single dropdown change turns an import into a
// wipe of whatever that graph already holds. It asks first, plainly, naming
// the graph by its name; a typed confirmation is kept for clearing every
// managed graph at once (Ch08 §2.5).

import { Button } from '@/components/ui/Button';
import { Modal } from '@/components/ui/Modal';
import { graphDisplayName } from '@/components/GraphSelector';

export function ConfirmGraphReplaceModal({
  graph,
  what,
  onCancel,
  onConfirm,
}: {
  /** The graph that will be dropped — the actual write target, not a label. */
  graph: string;
  /** What is about to be loaded, e.g. "this spreadsheet" or a file name. */
  what: string;
  onCancel: () => void;
  onConfirm: () => void;
}) {
  const name = graphDisplayName(graph);
  return (
    <Modal
      title="Replace graph contents"
      danger
      onClose={onCancel}
      footer={
        <>
          <Button variant="secondary" size="lg" onClick={onCancel}>
            Cancel
          </Button>
          <Button variant="dangerFilled" size="lg" onClick={onConfirm}>
            Drop {name} and load
          </Button>
        </>
      }
    >
      <p className="text-sm text-muted-foreground">
        Every statement in <strong className="text-tres-text-primary">{name}</strong>{' '}
        <span className="font-mono text-xs">({graph})</span> will be dropped before {what} is
        loaded. This cannot be undone — cancel and export the graph first if you need to keep it.
      </p>
    </Modal>
  );
}
